import DrawerInput from '@/components/analyticsPage/input/DrawerInput';
import MultiIndex from '@/components/analyticsPage/tabPanels/components/drawers/indexDrawer/components/components/multiIndex/MultiIndex';
import SingleIndex from '@/components/analyticsPage/tabPanels/components/drawers/indexDrawer/components/components/singleIndex/SingleIndex';
import { useIndexQuery } from '@/components/analyticsPage/tabPanels/components/drawers/indexDrawer/hooks/useIndexQuery';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

const IndexTab = () => {
  const [setQuery] = useIndexQuery();
  const tab = useSelector((state: any) => state.analytics.indexQuery);
  const handleTabChange = (target: string) => {
    setQuery({ target });
  };
  const [t] = useTranslation('analytics');

  return (
    <div>
      <DrawerInput data={tab} setQuery={setQuery} />
      <Tabs defaultValue="multiIndex" value={tab.target} onValueChange={handleTabChange}>
        <TabsList className="w-full">
          <TabsTrigger value="multiIndex" className="w-full">
            {t('Multi-index')}
          </TabsTrigger>
          <TabsTrigger value="singleIndex" className="w-full">
            {t('Single-index')}
          </TabsTrigger>
        </TabsList>
        <TabsContent value="multiIndex">
          <MultiIndex />
        </TabsContent>
        <TabsContent value="singleIndex">
          <SingleIndex />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default IndexTab;
